import Vue from "vue";
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

Vue.use(VuePersianDatetimePicker, {
    name: 'persian-datetime-picker',
    props: {
        type:'datetime',
        format: 'YYYY-MM-DD HH:mm:ss',
        displayFormat: 'dddd jDD jMMMM jYYYY ساعت HH:mm',
        inputClass: 'form-control',
        color: '#3daa89',
        clearable:true
    }
});
